import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const BackToTools = () => {
  const history = useHistory();
  const { i18n } = useTranslation();
  const isZh = i18n.language?.startsWith('zh');

  const handleClick = (event) => {
    event.preventDefault();
    history.push('/tools');
  };

  return (
    <a className={styles.link} href="/tools" onClick={handleClick}>
      {isZh ? '工具市场' : 'Tools'}
    </a>
  );
};

export default BackToTools;
